import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Check, Pencil, X } from "lucide-react";
import { memo } from "react";

interface PortfolioNameEditorProps {
  portfolio: any;
  isEditingName: boolean;
  portfolioName: string;
  onNameChange: (name: string) => void;
  onSave: () => void;
  onEditStart: () => void;
  onEditCancel: () => void;
}

export const PortfolioNameEditor = memo(({
  portfolio,
  isEditingName,
  portfolioName,
  onNameChange,
  onSave,
  onEditStart,
  onEditCancel,
}: PortfolioNameEditorProps) => {
  if (!portfolio) {
    return (
      <div className="space-y-2">
        <h1 className="text-2xl sm:text-3xl font-bold translate-z-0">Build New Portfolio</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Create and configure your investment portfolio
        </p>
      </div>
    );
  }

  if (isEditingName) {
    return (
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <Input
            value={portfolioName}
            onChange={(e) => onNameChange(e.target.value)}
            className="text-2xl sm:text-3xl font-bold h-12 max-w-md"
            autoFocus
            aria-label="Portfolio name"
          />
          <Button 
            onClick={onSave}
            variant="ghost"
            size="icon"
            aria-label="Save portfolio name"
          >
            <Check className="h-4 w-4" />
          </Button>
          <Button 
            onClick={onEditCancel}
            variant="ghost"
            size="icon"
            aria-label="Cancel editing"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Manage and track your investment portfolio
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <h1 className="text-2xl sm:text-3xl font-bold translate-z-0">{portfolio.name}</h1>
        <Button
          variant="ghost"
          size="icon"
          onClick={onEditStart}
          className="h-8 w-8"
          aria-label="Edit portfolio name"
        >
          <Pencil className="h-4 w-4" />
        </Button>
      </div>
      <p className="text-sm text-muted-foreground mt-1">
        Manage and track your investment portfolio
      </p>
    </div>
  );
});

PortfolioNameEditor.displayName = 'PortfolioNameEditor';